


































import Vue, { PropType } from 'vue';

interface DataType {
  isModalOpen: boolean;
}

export default Vue.extend({
  name: 'GInputLabel',
  data(): DataType {
    return {
      isModalOpen: false,
    };
  },
  props: {
    isLabel: { type: Boolean as PropType<boolean>, default: true },
    valid: { type: Boolean as PropType<boolean>, default: false },
    isTag: { type: Boolean as PropType<boolean>, default: false },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    exclamation: { type: Array as PropType<string[]>, default: () => [] },
    label: { type: String as PropType<string>, required: true },
    // error: { type: Array as PropType<string[]>, default: () => [] }, // 廃止予定
  },
  methods: {
    openDesicriptionModal() {
      this.isModalOpen = true;
    },
    closeDescriptionModal() {
      this.isModalOpen = false;
    },
  },
});
